var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-app-bar',{staticStyle:{"background-color":"#f8f8f8"},attrs:{"app":"","dense":"","flat":"","id":"navbar"}},[_c('p',{staticClass:"mt-4"},[_vm._v("Let's "),_c('span',{staticClass:"font-weight-bold purple--text"},[_vm._v("QUIZ")])]),_c('v-btn',{staticClass:"ml-auto",attrs:{"outlined":""}},[_vm._v("Log Out")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }